import React from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { BrowserRouter, Routes, Route} from 'react-router-dom';


import { About } from './views/About';
import { Home } from './views/Home';
import { Login } from './views/Login';
import { Signup } from './views/Signup';
import { Panel } from "./views/Panel";
import { Repository } from "./views/Repository";
import { RepositoryForm } from "./views/RepositoryForm";
import { RepositoryDoc } from "./views/RepositoryDoc";
import { Profil } from "./views/Profil";
import { Repositories } from "./views/Repositories";
import { Share } from "./views/Share";
import { Notification } from "./views/Notification";
import { Setting } from "./views/Setting";
import { EmailChecker } from "./views/SetEmailChecker";
import { Validation } from "./views/SetValidation";
import { Error } from "./views/404";
import { ForgottenPwd } from "./views/SetForgottenPwd";
import { UpdatePwd } from "./views/SetUpdatePwd";
import Secure from "./app/route/secure";
import { SharedRepository } from "./views/SharedRepository";


function App() 
{
  return (

    <div className="App">
        <BrowserRouter>
            <Routes>

                <Route exact path="/" element={ <Home /> }> </Route>
                <Route exact path="/apropos" element={ <About /> }> </Route>
                <Route exact path="/connexion" element={ <Login /> }> </Route> 
                
                <Route exact path="/inscription" element={ <Signup /> }> </Route> 
                <Route exact path="/nouveau-compte" element={ <EmailChecker /> }> </Route>
                <Route exact path="/activation/:token" element={ <Validation /> }> </Route>

                <Route exact path="/mp-oublie" element={ <ForgottenPwd /> }> </Route>
                <Route exact path="/mp-update/:token" element={ <UpdatePwd /> }> </Route>


                <Route exact path="/panel" element={ <Secure> <Panel /> </Secure> }> </Route>
                        
                        <Route path="/shared/:token" element={<SharedRepository />} />

                        <Route exact path="/rep/:id" element={ <Secure> <Repository /> </Secure>  }> </Route>

                                <Route exact path="/rep/:repid/:folderid" element={ <Secure> <RepositoryDoc /> </Secure>  }> </Route>

                        <Route exact path="/nouveau-repertoire" element={ <Secure> <RepositoryForm /> </Secure>  }> </Route>

                <Route exact path="/profile" element={ <Secure> <Profil /> </Secure> }> </Route>

                <Route exact path="/repertoires" element={ <Secure> <Repositories /> </Secure> }> </Route>

                        <Route exact path="/repertoires-partages" element={ <Secure> <Share /> </Secure> }> </Route>

                        <Route exact path="/notifications" element={ <Secure> <Notification /> </Secure> }> </Route>

                        <Route exact path="/parametre/:repid" element={ <Secure> <Setting /> </Secure> }> </Route>


                <Route exact path="*" element={ <Error />  } ></Route> 

            </Routes>
        </BrowserRouter>
    
    </div>
  );
}

export default App;
